import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    {...props}
  >
    <g strokeWidth={1.6}>
      <path
        fill="#d3dbe2"
        d="M16 0c8.864 0 16 7.136 16 16s-7.136 16-16 16S0 24.864 0 16 7.136 0 16 0"
      />
      <path
        fill="#0e0f10"
        fillOpacity={0.05}
        fillRule="evenodd"
        d="M16 0C7.164 0 0 7.164 0 16q0 .81.079 1.6C.882 9.515 7.704 3.2 16 3.2s15.118 6.315 15.921 14.4q.078-.79.079-1.6c0-8.836-7.163-16-16-16"
        clipRule="evenodd"
      />
      <path
        fill="#0e0f10"
        fillOpacity={0.05}
        fillRule="evenodd"
        d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.163 16-16S24.837 0 16 0m0 1.6C8.047 1.6 1.6 8.047 1.6 16S8.047 30.4 16 30.4 30.4 23.953 30.4 16 23.953 1.6 16 1.6"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M16 12.8c1.773 0 3.2 1.427 3.2 3.2s-1.427 3.2-3.2 3.2-3.2-1.427-3.2-3.2 1.427-3.2 3.2-3.2"
      />
    </g>
  </svg>
);
const SvgIconRadioButtonEnabledHover = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconRadioButtonEnabledHover);
export default Memo;
